import React, { useState } from "react";
import { Box, Paper, Fade } from "@mui/material";

import LoginForm from "../components/auth/LoginForm";
import RegisterForm from "../components/auth/RegisterForm";

export default function AuthPage() {
    const [mode, setMode] = useState("login");

    return (
        <Box
            sx={{
                width: "100%",
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "var(--backgroundPage)",
                p: 2,
            }}
        >
            <Paper
                elevation={6}
                sx={{
                    width: "100%",
                    maxWidth: 420,
                    p: 4,
                    borderRadius: "22px",
                    textAlign: "center",
                    background: "var(--branco)",
                }}
            >
                <Fade in={mode === "login"} unmountOnExit>
                    <Box>
                        <LoginForm onSwitch={() => setMode("register")} />
                    </Box>
                </Fade>

                <Fade in={mode === "register"} unmountOnExit>
                    <Box>
                        <RegisterForm onSwitch={() => setMode("login")} />
                    </Box>
                </Fade>
            </Paper>
        </Box>
    );
}
